module.exports = __webpack_public_path__ + "static/fonts/righteous-regular.7870e2e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/righteous-regular.woff2
// module id = EOYB
// module chunks = 1